import styled from "styled-components";
import { device } from "../../BreakPoints";

export const MainContainer = styled.div`
  padding: 46px 24px 72px;

  @media ${device.laptop} {
    padding: 46px 72px 72px;
  }
`;

export const InnerContainer = styled.div`
  margin: 0 auto;
  max-width: 1400px;
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
`;

export const Title = styled.div`
  border-radius: 34px;
  box-shadow: 0 0 21px -6px rgba(0, 0, 0, 0.5);
  color: #5f5f5f;
  font-size: 28px;
  margin-bottom: 40px;
  padding: 10px 0px;
  text-align: center;
`;

export const Wheel = styled.img`
  height: 170px;
  margin-bottom: 20px;
`;

export const Text = styled.div`
  color: #404042;
  font-size: 14px;
`;

export const Item = styled.div`
  max-width: 135px;
  text-align: center;
  margin-bottom: 20px;
`;
